var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.6035V8.60352C27.5 7.80787 27.1839 7.04481 26.6213 6.4822C26.0587 5.91959 25.2956 5.60352 24.5 5.60352H8.5C7.70435 5.60352 6.94129 5.91959 6.37868 6.4822C5.81607 7.04481 5.5 7.80787 5.5 8.60352V32.6035C5.5 33.3991 5.81607 34.1622 6.37868 34.7248C6.94129 35.2874 7.70435 35.6035 8.5 35.6035H24.5C25.2956 35.6035 26.0587 35.2874 26.6213 34.7248C27.1839 34.1622 27.5 33.3991 27.5 32.6035V25.6035",
    fill: "url(#paint0_linear_162_413)",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14.6035V8.60352C27.5 7.80787 27.1839 7.04481 26.6213 6.4822C26.0587 5.91959 25.2956 5.60352 24.5 5.60352H8.5C7.70435 5.60352 6.94129 5.91959 6.37868 6.4822C5.81607 7.04481 5.5 7.80787 5.5 8.60352V32.6035C5.5 33.3991 5.81607 34.1622 6.37868 34.7248C6.94129 35.2874 7.70435 35.6035 8.5 35.6035H24.5C25.2956 35.6035 26.0587 35.2874 26.6213 34.7248C27.1839 34.1622 27.5 33.3991 27.5 32.6035V25.6035",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.6035V18.6035H35.5V21.6035H21.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M9.5 14.6035V11.6035H23.5V14.6035H9.5Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.60352L18.5 7.60352H14.5L12.5 5.60352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_162_413",
    x1: 16.5,
    y1: 5.60352,
    x2: 16.5,
    y2: 35.6035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.c52a2d2a784781d29af6aa57c81597b6.svg";
export { ForwardRef as ReactComponent };